// The API is chosen by the address the app is loaded from (2026-10-09), so ONE build serves both sites and a
// staging → prod release can stay a bucket copy:
//   app.plunk.io / apps.plunk.io → ./production (api.plunk.io)
//   anything else (staging.plunk.io, localhost dev) → ./staging (api.staging.plunk.io)
// Before this, the staging branch imported ./staging at build time, so the copied bundle sent app.plunk.io to
// the staging API.
import staging from './staging';
import production from './production';
const PROD_HOSTS = ['app.plunk.io', 'apps.plunk.io'];
const host = typeof window !== 'undefined' && window.location ? window.location.hostname : '';
const endpoints = PROD_HOSTS.indexOf(host) > -1 ? production : staging;
export default endpoints;